import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchPincodeDetailsApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_PINCODE_DETAILS_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerFetchPincodeDetailsApiCall(actions) {
	const { data, callback } = actions;
	const formData = new FormData();
	formData.append('key', 'citystate');
	// formData.append('pincode', data['pincode'])
	// formData.append('city', '')
	// formData.append('state', '')
	formData.append(
		'params',
		JSON.stringify({
			pincode: data['pincode'],
			city: '',
			state: '',
		}),
	);
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.HANDSHAKE,
		url: '',
		method: 'POST',
		data: formData,
		options: {
			defaultLoader: false,
			restrictToast: true,
		},
	});
	if (api && api.data) {
		const apiData = api.data;
		callback && callback(apiData);
		yield put(triggerFetchPincodeDetailsApiCallSuccess(apiData));
	}
}

export default function* triggerFetchPincodeDetailsApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_PINCODE_DETAILS_API, triggerFetchPincodeDetailsApiCall);
}
